<app-confirmation-dialog [props]="confirmationDialogProps" id="tracking-reg-dialog">
  <form #inclusionForm="ngForm" style="width: 100%" id="tracking-reg-form">
    <div class="row d-flex flex-column">
      @if (isCreating) {
        <div class="col-12" id="tracking-reg-wallet-wrapper">
          <div class="form-group" style="margin-bottom: 4px">
            <label for="tracking-reg-select-wallet" class="col-form-label col-form-label-sm" i18n="@@js_wallet" id="tracking-reg-label-wallet">
            Cartera
          </label>
            <select
              id="tracking-reg-select-wallet"
              class="form-control form-control-sm"
              [class]="submited && walletField.invalid ? 'input-invalid' : ''"
              name="walletId"
              #walletField="ngModel"
              [(ngModel)]="selectedWalletId"
              required
              >
              <option value="" disabled selected hidden i18n="@@placeholderSelectWallet" id="tracking-reg-option-wallet-placeholder">
              Seleccione una cartera
            </option>
              @for (option of walletsList; track option) {
                <option [value]="option.id" [selected]="option" id="tracking-reg-option-wallet-{{option.id}}">
                  {{ option.name }}
                </option>
              }
            </select>
          </div>
          @if (!trackingRegistry.walletId) {
            <div
              id="tracking-reg-error-wallet-required"
          [ngClass]="{
            'mandatory-label': true,
            'mandatory-label__invalid': submited && walletField.invalid
          }"
              i18n="@@mandatoryName"
              >
          * Campo requerido
        </div>
          }
        </div>
      }

      <div class="col-12" id="tracking-reg-document-wrapper">
        <div class="form-group" style="margin-bottom: 4px">
          <label
            for="tracking-reg-input-document"
            class="col-form-label col-form-label-sm"
            i18n="@@label_document"
            id="tracking-reg-label-document"
            >
            Documento
          </label>
          <input
            class="form-control form-control-sm"
            [class]="submited && cpfCnpj.invalid ? 'input-invalid' : ''"
            id="tracking-reg-input-document"
            type="text"
            name="{{ documentText }}"
            #cpfCnpj="ngModel"
            [(ngModel)]="trackingRegistry.document"
            placeholder="Número válido de {{ documentText }}"
            mask="{{ getDocumentMask() }}"
            appUppercase
            [appCpfCnpjValidator]="documentText"
            [required]="isCreating"
            [disabled]="isEditing"
            />
          </div>
          @if (!trackingRegistry.document || cpfCnpj.invalid) {
            <div
              id="tracking-reg-error-document-invalid"
          [ngClass]="{
            'mandatory-label': true,
            'mandatory-label__invalid': submited && cpfCnpj.invalid
          }"
              >
              {{ invalidCPFCNPJMessage }}
            </div>
          }
        </div>

        @if (isEditing) {
          <div class="col-12" id="tracking-reg-name-wrapper">
            <div class="form-group" style="margin-bottom: 4px">
              <label for="tracking-reg-input-name" class="col-form-label col-form-label-sm" i18n="@@label_name" id="tracking-reg-label-name">
            Nombre
          </label>
              <input
                class="form-control form-control-sm"
                id="tracking-reg-input-name"
                type="text"
                name="personName"
                [(ngModel)]="trackingRegistry.name"
                disabled
                />
              </div>
            </div>
          }

          @if (isEditing) {
            <div class="col-12" id="tracking-reg-date-wrapper">
              <div class="form-group" style="margin-bottom: 4px">
                <label for="tracking-reg-input-date" class="col-form-label col-form-label-sm" i18n="@@inclusionDate" id="tracking-reg-label-date">
            Fecha de inclusión
          </label>
                <input
                  class="form-control form-control-sm"
                  id="tracking-reg-input-date"
                  type="text"
                  name="creationDate"
                  [(ngModel)]="trackingRegistry.creationDate"
                  disabled
                  />
                </div>
              </div>
            }

            @if (!isEditing) {
              <div class="col-12" id="tracking-reg-followup-wrapper">
                <div class="form-group" style="margin-bottom: 4px">
                  <label for="tracking-reg-select-followup" class="col-form-label col-form-label-sm" i18n="@@Followed_time" id="tracking-reg-label-followup">
            Tiempo de seguimiento
          </label>
                  <select
                    id="tracking-reg-select-followup"
                    class="form-control form-control-sm"
                    name="followUpTime"
                    [(ngModel)]="trackingRegistry.followUpType"
                    >
                    @for (option of followUpTime; track option; let iFUP = $index) {
                      <option
                        [value]="option.value"
                        [selected]="option.value === trackingRegistry.followUpType"
                        id="tracking-reg-option-followup-{{iFUP}}"
                        >
                        {{ option.label }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            }

            <div class="col-12" id="tracking-reg-code-wrapper">
              <div class="form-group" style="margin-bottom: 4px">
                <label
                  for="tracking-reg-input-code"
                  class="col-form-label col-form-label-sm"
                  i18n="@@internalCode2"
                  id="tracking-reg-label-code"
                  >
            Código interno
          </label>
                <input
                  id="tracking-reg-input-code"
                  type="text"
                  class="form-control form-control-sm"
                  maxlength="30"
                  [(ngModel)]="trackingRegistry.internalCode"
                  name="internalCode"
                  placeholder="<Campo opcional>"
                  appInputRegex
                  />
                </div>
              </div>

              <div class="col-12" id="tracking-reg-segment-wrapper">
                <div class="form-group" style="margin-bottom: 4px">
                  <label for="tracking-reg-input-segment" class="col-form-label col-form-label-sm" i18n="@@segment" id="tracking-reg-label-segment">
            Segmento
          </label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="tracking-reg-input-segment"
                    maxlength="30"
                    [(ngModel)]="trackingRegistry.segment"
                    name="segment"
                    placeholder="<Campo opcional>"
                    appInputRegex
                    />
                  </div>
                </div>
              </div>
            </form>
          </app-confirmation-dialog>
